<template>
    <v-layout justify-center align-center dd-dark lighten-1 class="white--text" px-5 py-5 :class="{'animated' : animated}" fadeIn delay-1s >
        <slot name="content"></slot>
    </v-layout>
</template>
<script>
export default{
    props:{
        animated: {
            type: Boolean,
            default: true
        }
    }
}
</script>